import HttpService from "./HttpService";
const MODULE_PREFIX = "/project";
const API_URL = `${MODULE_PREFIX}-task`;

const MyTeamProjectService = {
  fetchProject: async () => {
    try {
      const response = await HttpService.get(`${MODULE_PREFIX}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching projects:", error);
      throw error;
    }
  },
  fetchTeamProjects: async () => {
    try {
      const response = await HttpService.get(`${MODULE_PREFIX}-created`);
      return response.data;
    } catch (error) {
      console.error("Error fetching projects:", error);
      throw error;
    }
  },
  fetchProjectPaginated: async (pageConfig) => {
    const pageConfigParams = new URLSearchParams(pageConfig);
    try {
      const response = await HttpService.get(
        `${MODULE_PREFIX}-paginated?${pageConfigParams}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching projects:", error);
      throw error;
    }
  },
  fetchProjectMembers: async (id) => {
    try {
      const response = await HttpService.get(`${MODULE_PREFIX}-member/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching projects:", error);
      throw error;
    }
  },
  addProject: async (data) => {
    try {
      const response = await HttpService.post(MODULE_PREFIX, data, {
        headers: {
          "Content-Type": "multipart/form-data",
          // Add any other headers if required
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error adding project:", error);
      throw error;
    }
  },

  editProject: async (projectId) => {
    try {
      const response = await HttpService.get(
        `${MODULE_PREFIX}/${projectId}/edit`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateProject: async (projectId, updatedProject) => {
    updatedProject["_method"] = "PUT";
    try {
      const response = await HttpService.post(
        `${MODULE_PREFIX}/${projectId}`,
        updatedProject,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error updating project:", error);
      throw error;
    }
  },

  deleteProject: async (projectId) => {
    try {
      const response = await HttpService.delete(
        `${MODULE_PREFIX}/${projectId}`
      );
      return response.data;
    } catch (error) {
      console.error("Error deleting project:", error);
      throw error;
    }
  },
  fetchTasks: async () => {
    try {
      const response = await HttpService.get(`${API_URL}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching tasks:", error);
      throw error;
    }
  },
  fetchEmployeeTasks: async () => {
    try {
      const response = await HttpService.get(`/employee-project-task`);
      return response.data;
    } catch (error) {
      console.error("Error fetching tasks:", error);
      throw error;
    }
  },
  fetchTasksPaginated: async (pageConfig) => {
    const pageConfigParams = new URLSearchParams(pageConfig);
    try {
      const response = await HttpService.get(
        `${API_URL}-paginated?${pageConfigParams}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching tasks:", error);
      throw error;
    }
  },
  fetchProjectTasks: async (id, pageConfig) => {
    const pageConfigParams = new URLSearchParams(pageConfig);
    try {
      const response = await HttpService.get(
        `${API_URL}-list/${id}?${pageConfigParams}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching tasks:", error);
      throw error;
    }
  },

  addTask: async (data) => {
    try {
      const response = await HttpService.post(API_URL, data, {
        headers: {
          "Content-Type": "multipart/form-data",
          // Add any other headers if required
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error adding task:", error);
      throw error;
    }
  },

  editTask: async (taskId) => {
    try {
      const response = await HttpService.get(`${API_URL}/${taskId}/edit`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateTask: async (taskId, updatedProject) => {
    updatedProject["_method"] = "PUT";
    try {
      const response = await HttpService.post(
        `${API_URL}/${taskId}`,
        updatedProject,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error updating task:", error);
      throw error;
    }
  },

  deleteTask: async (projectId) => {
    try {
      const response = await HttpService.delete(`${API_URL}/${projectId}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting task:", error);
      throw error;
    }
  },
};

export default MyTeamProjectService;
